// Icons
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import PeopleIcon from "@mui/icons-material/People";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import UndoIcon from "@mui/icons-material/Undo";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EditIcon from "@mui/icons-material/Edit";
import GroupsIcon from "@mui/icons-material/Groups";
import PublicIcon from "@mui/icons-material/Public";
import BusinessIcon from "@mui/icons-material/Business";
import AddTaskIcon from "@mui/icons-material/AddTask";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import EditLocationIcon from "@mui/icons-material/EditLocation";

export function useUserAccessList(userCard) {
  const access = {
    alloworders: {
      value: userCard.alloworders,
      title: "Orders",
      desc: "Create and edit draft orders",
      icon: <AddShoppingCartIcon />,
    },
    allowcheckout: {
      value: userCard.allowcheckout,
      title: "Checkout",
      desc: "Checkout your own or colleagues orders",
      icon: <ShoppingCartRoundedIcon />,
    },
    allowstaff: {
      value: userCard.allowstaff,
      title: "Staff",
      desc: "View the staff list",
      icon: <PeopleIcon />,
    },
    staffAllBranches: {
      value: userCard.staffAllBranches,
      title: "Global Staff",
      desc: "View staff from all branches",
      icon: <GroupsIcon />,
    },
    staffCreate: {
      value: userCard.staffCreate,
      title: "Create Staff",
      desc: "Create new staff members",
      icon: <PersonAddIcon />,
    },
    staffEdit: {
      value: userCard.staffEdit,
      title: "Edit Staff",
      desc: "Edit existing staff members",
      icon: <EditIcon />,
    },
    allowwardrobes: {
      value: userCard.allowwardrobe,
      title: "Wardrobes",
      desc: "View wardrobes and items",
      icon: <CheckroomIcon />,
    },
    allowentitlement: {
      value: userCard.allowentitlement,
      title: "Entitlement",
      desc: "View and control staff entitlement",
      icon: <RefreshIcon />,
    },
    allowreturns: {
      value: userCard.allowreturns,
      title: "Returns",
      desc: "Return previous orders",
      icon: <UndoIcon />,
    },
    allowfinances: {
      value: userCard.allowfinances,
      title: "Finances",
      desc: "View and monitor your finances",
      icon: <CreditCardIcon />,
    },
    allowcontracts: {
      value: userCard.allowcontracts,
      title: "Contracts",
      desc: "Create and edit contracts",
      icon: <NoteAltIcon />,
    },
    allowgeneralreports: {
      value: userCard.allowgeneralreports,
      title: "General Reports",
      desc: "	Download general reports",
      icon: <DataUsageIcon />,
    },
    allowfinancialreports: {
      value: userCard.allowfinancialreports,
      title: "Financial Reports",
      desc: "Download financial reports",
      icon: <StackedBarChartIcon />,
    },
    addressCreate: {
      value: userCard.addressCreate,
      title: "Address Create",
      desc: "Create new shipping addresses",
      icon: <AddLocationIcon />,
    },
    addressEdit: {
      value: userCard.addressEdit,
      title: "Address Edit",
      desc: "Edit and delete addresses",
      icon: <EditLocationIcon />,
    },
    addressListBranch: {
      value: userCard.addressListBranch,
      title: "Address List Branches",
      desc: "View addresses assigned to your branches",
      icon: <BusinessIcon />,
    },
    addressListCompany: {
      value: userCard.addressListCompany,
      title: "Address List Global",
      desc: "View all addresses in the address list",
      icon: <PublicIcon />,
    },
    staffRequestCreate: {
      value: userCard.staffRequestCreate,
      title: "Create Requests",
      desc: "Create Uniform Requests",
      icon: <AddTaskIcon />,
    },
    staffRequestApprove: {
      value: userCard.staffRequestApprove,
      title: "Approve Requests",
      desc: "Approve Uniform Requests",
      icon: <CheckCircleIcon />,
    },
  };

  return access;
}
